import { useRef, useEffect } from 'react';

import { onKeyDown, onPaste } from './input.func';
import { Content } from './input.styled';

export const InputUncontrolled = (props) => {
  const { value, onChange, asNumber, minValue = 0, maxValue = 999, ...rest } = props;
  const inputRef = useRef(null);

  const change = (event) => {
    let val = event.target.value;
    if (asNumber) {
      val = parseInt(val);
      if (Number.isNaN(val)) {
        inputRef.current.value = value;
        return;
      }

      if (val < minValue) {
        val = minValue;
      }
      if (val > maxValue) {
        val = maxValue;
      }
    }
    onChange(val);
  };

  useEffect(() => {
    inputRef.current.value = value;
  }, [value]);

  const other = {};
  if (asNumber) {
    other.onKeyDown = onKeyDown;
    other.onPaste = onPaste;
  }

  return <Content ref={inputRef} type="text" defaultValue={value} onBlur={change} {...rest} {...other} />;
};
